import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AvatarBackgroundSizes, AvatarShapes } from 'mojo-avatar';
import { MojoFeatureExtensionsService } from 'mojo-feature-extensions';
import { Observable } from 'rxjs';
import { distinctUntilChanged, filter, map, pluck, shareReplay, switchMap } from 'rxjs/operators';

import { AppFeatureExtensions, JobFilterExtensions } from '@app/app-feature-extensions.config';
import { getAssociationLabel } from '@collections/association-label';
import { getCompanyById } from '@collections/companies';
import { getJob, JobsGet } from '@collections/jobs';
import { isAssociationRejected } from '@modules/assigns/store';
import { Association, AssociationLabel, Company, Job } from '@shared/models';
@Component({
  selector: 'mojo-assigns-job-container',
  templateUrl: './assigned-job.container.html',
  styleUrls: ['./assigned-job.container.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AssignedJobContainerComponent implements OnInit {
  @Input() association: Association;

  directApplicant = AssociationLabel.DIRECT;

  avatarShapes = AvatarShapes;
  avatarSize = AvatarBackgroundSizes.cover;

  job$: Observable<Job>;
  company$: Observable<Company>;

  jobStatusFilterFeature$: Observable<JobFilterExtensions> =
    this.featureExtensionsService.licenseFeatureExtensions$.pipe(
      map((extensions) =>
        extensions.includes(AppFeatureExtensions.JOB_STATUSES_BASIC)
          ? AppFeatureExtensions.JOB_STATUSES_BASIC
          : AppFeatureExtensions.JOB_STATUSES_ALL,
      ),
    );

  associationLabel$: Observable<string>;

  isOnRejectedState$: Observable<boolean>;

  constructor(
    private featureExtensionsService: MojoFeatureExtensionsService,
    private store: Store<{}>,
  ) {}

  ngOnInit() {
    const params = { id: this.association.reqId };
    const props = {
      jobId: this.association.reqId,
      candidateId: this.association.candidateId,
    };

    this.job$ = this.store.select(getJob(this.association.reqId));
    this.company$ = this.job$.pipe(
      filter((job) => job && !!job.companyId),
      pluck('companyId'),
      distinctUntilChanged(),
      switchMap((companyId) => this.store.select(getCompanyById, { id: companyId })),
      shareReplay(1),
    );
    this.store.dispatch(new JobsGet(params));

    this.associationLabel$ = this.store.select(getAssociationLabel, props);

    this.isOnRejectedState$ = this.store.select(isAssociationRejected, {
      jobId: this.association.reqId,
      phaseId: this.association.status,
      stateId: this.association.subStatus,
    });
  }
}
